module.exports = __webpack_public_path__ + "img/commander20.png";